<template>
 <div class="container vertical-align login">
      <div class="row">
        <div class="col-md-5">
          <form class="form-signin">
            <TopoComponent :empresa="nomeempresa"></TopoComponent>
            <h1 class="h1 font-weight-normal">Suporte</h1>
              <div class="row text-center">
                <p  style="margin-top: 30px; margin-bottom: 0px; font-weight: bold;">Caso o chat não abra automaticamente, clique no botão abaixo.</p>
                 <button type="button" class="btn btn-primary btn-lg" style="width: 300px; margin-top:20px" @click="openChat">FALAR COM O SUPORTE</button>
              </div>  
              <div class="clearfix"></div>
            <div class="relative">
            </div>
          </form>
        </div>
        <div class="col-md-7">
          <img :src="image('medico.svg')" alt="" class="img-fluid float-right medico">
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
</template>

<script>
import TopoComponent from '@/components/TopoComponent'
import { getImage } from "../components/utils/fnUtils";

export default {
    components: { TopoComponent },
    props: ['empresa'],
    created(){
       this.nomeempresa = this.empresa
    },
    beforeMount() {
        if(this.empresa && this.empresa.toLowerCase() === 'docpass'){
            document.getElementById("estilo_conexa").setAttribute('disabled', 'disabled');
            document.getElementById("estilo_docpass").removeAttribute('disabled');
            sessionStorage.setItem('layout', 'docpass');
        }
    },
    mounted() {
    setTimeout(() => {
      window.location.href = process.env.VUE_APP_NOVA_ATIVACAO_PACIENTE;
    }, 1000);
  },
    data() {
      return {
          nomeempresa: null
      }
  },
    methods:{
      irParaHome(){
        location.href = '/'
      },
      openChat(){
         zE(function() {
          // eslint-disable-next-line
          zE.activate();
            $zopim(function() {
                $zopim.livechat.addTags("cpf", sessionStorage.getItem("cpf")); 
                $zopim.livechat.addTags("clinica", sessionStorage.getItem("idclinica")); 
                $zopim.livechat.addTags("empresa", sessionStorage.getItem("empresa")); 
                $zopim.livechat.addTags("origem", sessionStorage.getItem("origem")); 
                $zopim.livechat.addTags("local", "Ativação paciente"); 
              //$zopim.livechat.window.setPosition('bl'); 
                $zopim.livechat.badge.show();
            });
          zE.show();  
        })
      },
      image(name){
            return getImage(name)
        }
    }
}
</script>